import { React } from "react";
import { TodaysDate } from "../../../utils/DateUtils";
import { AiOutlineCalendar } from "react-icons/ai";
import { BiArrowBack } from "react-icons/bi";
import PropTypes from "prop-types";

function Navigation({setTab}) {
	let date = TodaysDate();
	return (
		<div className='space-between'>
				<div onClick={setTab} style={{ color: "#408D94" }} className='flex gap-2 border'>
					<BiArrowBack size={24} />
					<p>Go back</p>
				</div>

			<div className='flex gap-2 '>
				<AiOutlineCalendar size={24} style={{ color: "#D9D9D9" }} />
				<p>{date}</p>
			</div>
		</div>
	);
}

Navigation.propTypes = {
	setTab: PropTypes.func,
};

export default Navigation;
